import { Pipe, PipeTransform } from "@angular/core";
import { NgxTranslateService } from "../shared/ngx-translate.service";

@Pipe({
  name: "verifystate"
})
export class VerificationStatePipe implements PipeTransform {
  constructor(private translateService : NgxTranslateService){

  }
  transform(value: string, args: any[]): any {
    switch (value) {
      case "VerificationRequestSent":
        return this.translateService.getText('Acc_War_InProgress', "In Progress") ;
      case "Verified":
        return this.translateService.getText('Acc_War_Verified', "Verified");
      case "StopReceived":
        return this.translateService.getText('Acc_War_StopRecieved', "Stop Received");
      case "NotVerified":
      default:
        return this.translateService.getText('Acc_War_NotVerified', "Not Verified");
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/account/verification-state.pipe.ts